import { Box, Chip, Tooltip } from '@mui/material';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { teamsJotaiAtom } from '../jotai/atoms';

export interface TeamIconProps extends React.ComponentPropsWithoutRef<'div'> {
  id: string;
  button?: boolean;
}

const styles = {
  root: {
    position: 'relative',
    backgroundColor: '#B4C1CC',
    borderRadius: '8px',
    width: 160,
    height: 160,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  button: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#c8cacc'
    }
  },
  disabled: {
    filter: 'grayscale(1)',
    opacity: 0.5
  },
  img: {
    maxWidth: '90%'
  },
  chip: {
    position: 'absolute',
    top: 4,
    left: 4,
    borderRadius: '8px'
  },
  tooltip: {
    fontSize: '1rem',
    lineHeight: 1.1
  }
} as const;

export function TeamIcon({ id, button, ...props }: TeamIconProps) {
  const team = useAtomValue(teamsJotaiAtom(id));

  return (
    <Tooltip
      open={Boolean(!team?.enabled && button)}
      arrow
      placement="top"
      title={
        <Box component="span" sx={styles.tooltip}>
          弊社から回答をお待ちいただく間、
          <br />
          こちらでデモをご覧いただけます
        </Box>
      }
      disableHoverListener
    >
      <Box sx={[styles.root, button ? styles.button : {}]} {...props}>
        {team?.enabled ? null : (
          <Chip
            label="お支払い情報 未設定"
            sx={styles.chip}
            color="primary"
            size="small"
          />
        )}
        <Box
          component="img"
          src={team?.iconUrl || require('../resources/default-icon.png')}
          alt=""
          sx={[styles.img, !team?.enabled ? styles.disabled : {}]}
        />
      </Box>
    </Tooltip>
  );
}
